import firebase from 'firebase';
import { CookingIngredient } from '../../models/menuItem';

export const serializeCookingIngredientSnap = (cookingIngredient: firebase.firestore.DocumentSnapshot): CookingIngredient => {
  const data = cookingIngredient.data() ?? {};
  return serializeCookingIngredient(cookingIngredient.ref.path, data);
};

export const serializeCookingIngredient = (
  path: string,
  data: {[key:string]: any}
): CookingIngredient => {
  return {
    allergens: data.allergens ?? [],
    diets: data.diets ?? [],
    meta: data.meta ?? {},
    name: data.name ?? "",
    path: path,
  }
};